import { render, staticRenderFns } from "./LabelChip.vue?vue&type=template&id=1e65e6c3&scoped=true&"
import script from "./LabelChip.vue?vue&type=script&lang=ts&"
export * from "./LabelChip.vue?vue&type=script&lang=ts&"
import style0 from "./LabelChip.vue?vue&type=style&index=0&id=1e65e6c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65e6c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
